import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/userdetails/getActiveUsersList/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&isPagination=1&pageNo=1&perPageRec=2
export const getActiveUserListAPIURL = BaseURl + "userdetails/getActiveUsersList/v1/";

//https://testcockpit.p2k.in/api/userdetails/getUserGroupCallsAvailability/v1/?employeeUUID=11efc01a-3d65-34c2-9d30-22f17ecb52c4
export const getUserPermissionAPIURL = BaseURl + "userdetails/getUserGroupCallsAvailability/v1/";


//https://testcockpit.p2k.in/api/userdetails/changeEmpCallingGroupPermission/v1/
export const patchUserPermissionAPIURL = BaseURl + "userdetails/changeEmpCallingGroupPermission/v1/";